import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {UserAclService} from '../../services/infrastructure/auth/acl/user-acl/user-acl.service';
import {GuardService} from '../guard/guard.service';

export const gccCollectionGuard: CanActivateFn = () => {
  const guardService = inject(GuardService);
  const userAclService = inject(UserAclService);

  const hasPermissions = userAclService.isInsurerRole()
    || userAclService.isApplicationAdmin()
    || userAclService.isLibraryAdmin();
  if (hasPermissions) {
    return true;
  }
  return guardService.createRedirectUrlTree();
};
